/*
templates.push({
  "title" : "",
  "desc" : ``,
  "img" : "assets/template/.png",
  "xml" : ``
}); 
*/
import { template1 } from './template1';

export const templates_dhu = [template1];
